import { Alert, Button, TableCell, TableRow } from "@mui/material";
import MUIDataTable from "mui-datatables";
import React from "react";
import { useContext, useState } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import CourseAllocationForAssignmentOfOtherDept from "./CourseAllocationForAssignmentOfOtherDept";
import CourseTableCourseOffering from "./CourseTableCourseOffering";
import Decline from "./Decline";
import StaffComponent from "./StaffComponent";

function NotRejectedRequests({
  getAssignmentCourses,
  notRejectedCoursesData,
  AssCourses,
  setAssCourses,
}) {
  let [alertRejectFailed, setalertRejectFailed] = useState(false);

  let [loading, setLoading] = useState(false);
  let { coursetoReject, setCoursetoReject } = useContext(
    CourseAssignmentContext
  );

  function rejectalignwithdatabase(code) {
    let arr = [];

    AssCourses.forEach((course) => {
      if (course.course_code == code) {
        course.declined = true;
      }

      arr.push(course);
    });

    setAssCourses(arr);
  }
  const columns = [
    {
      name: "Course Name",
      options: {
        filter: false,
      },
    },
    {
      name: "Code",
      options: {
        filter: false,
      },
    },
    {
      name: "Cr.Hr",
      options: {
        filter: false,
      },
    },
    {
      name: "LEH",
      options: {
        filter: false,
      },
    },
    {
      name: "Requested By",
      options: {
        filter: true,
      },
    },
    {
      name: "Action",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button
              onClick={() => {
                setCoursetoReject({
                  ...coursetoReject,
                  courseCode: value.courseCode,
                  requester: value.requester,
                  requestedTo: value.requestedTo,
                  batch: value.batch,
                });
              }}
              sx={{
                border: "1px solid gray",
                color: "red",
              }}
              variant="outlined"
            >
              {value.reject}
            </Button>
          );
        },
      },
    }, //for filter of batch on front end
    {
      name: "Batch",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Admission Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Program Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
  ];

  const options = {
    print: "false",
    download: "false",
    selectableRows: "none",
    filterType: "dropdown",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    pagination: true,
    responsive: "vertical",
    expandableRows: true,

    renderExpandableRow: (rowData, rowMeta) => {
      let currentcourse = AssCourses.filter(
        (course) => course.course_code == rowData[1]
      );
      const colSpan = rowData.length + 1;

      let courseDept;
      let courseOwner;
      let department;
      let batch;
      if (currentcourse.length > 0) {
        courseDept = currentcourse[0].Office.id;
        courseOwner = currentcourse[0].owner;
        department = currentcourse[0].Curriculums[0].owner;
        batch = currentcourse[0].batch;
      } else {
        courseDept = null;
        courseOwner = null;
        department = null;
        batch = null;
      }
      return (
        <React.Fragment>
          <TableRow sx={{ padding: "0px" }}>
            <TableCell colSpan={colSpan}>
              <CourseTableCourseOffering cID={rowData[1]} />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={colSpan}>
              <CourseAllocationForAssignmentOfOtherDept
                courseCode={rowData[1]}
                courseDept={courseDept}
                courseOwner={courseOwner}
                department={department}
                batch={batch}
              />
            </TableCell>
          </TableRow>
        </React.Fragment>
      );
    },
  };

  return (
    <div className="AssCourseTableWrapper">
      {alertRejectFailed == true && (
        <Alert sx={{ fontSize: "18px", fontWeight: "500" }} severity="warning">
          Can't Reject while you have assigned for a group!
        </Alert>
      )}
      {loading == false ? (
        <div className="AssCourseDivContainer">
          <div className="coursesInAssCourses">
            <MUIDataTable
              title={"Course List"}
              data={notRejectedCoursesData}
              columns={columns}
              options={options}
            />
          </div>
          <div className="staffInAssCourses">
            <StaffComponent />
          </div>
        </div>
      ) : (
        <h1>loading</h1>
      )}

      {coursetoReject.courseCode != null && (
        <Decline
          getAssignmentCourses={getAssignmentCourses}
          setalertRejectFailed={setalertRejectFailed}
          rejectalignwithdatabase={rejectalignwithdatabase}
        />
      )}
    </div>
  );
}

export default NotRejectedRequests;
